import { useEffect, useState, } from 'react'
import { getError, getResponse, settings } from '../helpers/UtilsHelper';
import { AuthContext } from './AuthContext';
import { LoginService } from '../services/login/LoginService';
import { RoleSessionClass } from '../classes/role/roleSessionClass';

const { localStorage: gsLocalStorage } = settings;

export default function AuthProvider({ children }) {
    const [account, setAccount] = useState(
        JSON.parse(localStorage.getItem(gsLocalStorage?.accountId)) || null
    );

    useEffect(() => {
        try {
            localStorage.setItem(gsLocalStorage?.accountId, JSON.stringify(account));
        } catch (ex) {
            localStorage.removeItem(gsLocalStorage?.accountId);
        }
    }, [account]);

    const login = async ({
        email = '',
        password = '',
        rememberMe = false,
        accountDataSave = false,
        reCaptchaToken = '',
        languageId = 'en',
        subMethod = '',
    }) => {
        const currentMethod = 'login';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let loginData = {};
            let accountFirebase = {};
            //#endregion variables

            //#region process
            response = await LoginService?.login({
                email: email,
                password: password,
                rememberMe: rememberMe,
                reCaptchaToken: reCaptchaToken,
                languageId: languageId,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return response;

            loginData = response.result;

            response = setAccountLocal({
                accountML: loginData?.accountML,
                accountFirebase: loginData?.accountFirebase,
                token: loginData?.token,
                role: loginData?.role,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return response;

            accountFirebase = response?.result?.accountFirebase || {};

            if (accountDataSave) {
                setAccount(accountFirebase);
            } else {
                response = logout({
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return response;
            }
            //#endregion process
        } catch (ex) {
            logout({
                subMethod: currentMethod
            });
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setAccountLocal = ({
        accountML = {},
        accountFirebase = {},
        token = {},
        role = RoleSessionClass?.getClass(),
        subMethod = '',
    }) => {
        const currentMethod = 'setAccountLocal';
        let response = getResponse({ type: 0 });
        try {
            accountFirebase.tokenVzLaML = token;
            // accountFirebase.role = {
            //     roleUserId: accountML?.roleUserId,
            //     roleDate: accountML?.roleDate,
            //     role: accountML?.role,
            //     roleId: accountML?.roleId,
            // };
            accountFirebase.role = role;
            response.result = {
                accountML: accountML,
                accountFirebase: accountFirebase,
                token: token,
            };
        } catch (ex) {
            logout({
                subMethod: currentMethod,
            });
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const logout = ({
        savePath = false,
        subMethod = '',
    }) => {
        const currentMethod = 'logout';
        let response = getResponse({ type: 0 });
        try {
            if (savePath) {
                localStorage.setItem(gsLocalStorage?.redirectId, window?.location?.pathname);
            } else {
                localStorage.removeItem(gsLocalStorage?.redirectId);
            }

            response = removeAccount({
                subMethod: currentMethod,
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const isLoged = () => {
        return !!account;
    }

    const removeAccount = ({
        subMethod = '',
    }) => {
        const currentMethod = 'removeAccount';
        let response = getResponse({ type: 0 });
        try {
            setAccount(null);
            localStorage.removeItem(gsLocalStorage?.accountId);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const updateAccountLocal = ({
        accountNew = {},
        subMethod = '',
    }) => {
        const currentMethod = 'updateAccountLocal';
        let response = getResponse({ type: 0 });
        try {
            localStorage.removeItem(gsLocalStorage?.accountId);
            setAccount(accountNew);
            localStorage.setItem(gsLocalStorage?.accountId, JSON.stringify(accountNew));
            response.result = accountNew;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const value = {
        account: account,
        login: login,
        setAccountLocal: setAccountLocal,
        logout: logout,
        isLoged: isLoged,
        removeAccount: removeAccount,
        updateAccountLocal: updateAccountLocal,
    };

    return <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>
}